import styled from 'styled-components';
import Button from '@anm/components/buttons/Button/Button';
import { media } from '@anm/styles/helpers';

const currentPlanRowMobile = media.phone`
  flex-direction: column;
  align-items: flex-start;
  ${Button} {
    margin-top: 17px;
    &:first-child:last-child {
      margin-left: 0;
    }
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: auto;
  ${Button}:first-child:last-child {
    margin-left: auto;
  }
  ${currentPlanRowMobile};
`;

export const CurrentPlanRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 17px;
  ${currentPlanRowMobile};
`;

export const CancelButton = styled(Button)`
  text-decoration: underline;
  font-size: 15px;
  color: #a0a0a7;
`;
